import { ErrorIcon, SuccessIcon } from "@theme/assets/icons";

import { getThemeValue } from "@theme/components";

import type { ThemeUIStyleObject } from "@theme/components";

const alertVariants = {
  success: {
    bg: "backgroundSuccess",
    border: "borderSuccess",
    iconColor: "textSuccess",
  },
  error: {
    bg: "backgroundError",
    border: "borderError",
    iconColor: "textError",
  },
  disclaimer: {
    bg: "backgroundLevel2",
    border: "borderLevel2",
    iconColor: "textLevel3",
  },
} as const;

export const alertStyles = (
  variant: "error" | "success" | "disclaimer",
  isToast: boolean,
): Record<"root" | "container" | "icon" | "content", ThemeUIStyleObject> => ({
  root: {
    width: "full",
    bg: alertVariants[variant].bg,
    py: "s200",
    pl: "s200",
    my: isToast ? "s200" : 0,
    pr: isToast ? 0 : "s400",
    borderRadius: "xs",
    ...(isToast
      ? {
          boxShadow: "alert",
        }
      : {
          borderColor: alertVariants[variant].border,
          borderStyle: "solid",
          borderWidth: 1,
        }),
  },
  container: {
    borderLeft: (t) => `4px solid ${getThemeValue(t, `colors.${alertVariants[variant].border}`)}`,
    pl: "s400",
    py: "s100",
    alignItems: "flex-start",
  },
  icon: {
    mt: "s50",
    minWidth: 20,
    width: 20,
    height: 20,
    alignItems: "center",
    justifyContent: "center",
    color: alertVariants[variant].iconColor,
  },
  content: {
    flexDirection: "column",
    gap: "s50",
    pl: "s300",
    textAlign: "left",
    color: "textPrimary",
  },
});

export const alertIcons = {
  success: SuccessIcon,
  error: ErrorIcon,
  disclaimer: ErrorIcon,
} as const;
